export function tryParseJson<T>(jsonString: string): T {
  try {
    return JSON.parse(jsonString) as T;
  } catch {
    return null;
  }
}